// Lucide icon: calendar (https://lucide.dev/icons/calendar)
import { Calendar } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconCalendar = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Calendar />
    </IconComponentStyled>
  )
}
